import axiosClient from "../axios/axiosClient";

export function getStaffs() {
  return axiosClient.get("/staff");
}

export function getStaff(staffId) {
  return axiosClient.get(`/staff/${staffId}`);
}

export function createStaff(data) {
  return axiosClient.post("/staff", data);
}

export const updateStaff = (staffId, data) => {
  return axiosClient.put(`/staff/${staffId}`, data);
};

export function deleteStaff(staffId) {
  return axiosClient.delete(`/staff/${staffId}`);
}

export const exportStaffTemplate = () => {
  return axiosClient.get(`staff-registration-template`, {
    responseType: "arraybuffer",
  });
};

export const importStaffTemplate = (data) => {
  return axiosClient.post(`/staff-bulk-upload`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
